<div class="background">
  <div class="center-container d-flex justify-content-center align-items-center my-auto">
    <div class="center p-5 border rounded shadow w-25">
      <div class="display-6 fw-bold opacity-60 mb-5">Register User</div>
      <form method="post" class="d-flex flex-column gap-3">
        <div class="form-floating">
          <input type="text" class="form-control" id="username" name="username" placeholder="username" [(ngModel)]="username" required />
          <label for="username">Username</label>
        </div>
        <div class="input-group border rounded">
          <div class="form-floating">
            <input [type]="showPassword ? 'text' : 'password'" class="form-control border-0" id="password" name="password" placeholder="password" [(ngModel)]="password" required />
            <label for="password">Password</label>
          </div>
          @if (password) {
            <button class="btn text-secondary border-0" type="button" (click)="showPassword = !showPassword">
              <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          }
        </div>
        <div class="input-group border rounded">
          <div class="form-floating">
            <input [type]="showRepeatPassword ? 'text' : 'password'" class="form-control border-0" id="repeatPassword" name="repeatPassword" placeholder="repeatPassword" [(ngModel)]="repeatPassword" required />
            <label for="repeatPassword">Confirm Password</label>
          </div>
          @if (repeatPassword) {
            <button class="btn text-secondary border-0" type="button" (click)="showRepeatPassword = !showRepeatPassword">
              <i class="fas" [ngClass]="showRepeatPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          }
        </div>
        <div class="form-floating">
          <select id="role" name="role" class="form-control" [(ngModel)]="selectedRole" required>
            <option value="0" disabled selected hidden>SELECT A ROLE</option>
            @for (role of roleList; track role.ID) {
              <option [ngValue]="role.ID">{{ role.Name }}</option>
            }
          </select>
          <label for="role">Role</label>
        </div>
        @if (selectedRole && includesSelectedRole([enums.STAFF, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.BOOKKEEPING_STAFF])) {
          <div class="form-floating">
            <input type="number" class="form-control" id="initialCashAmount" name="initialCashAmount" placeholder="Initial Cash Amount" [(ngModel)]="initialCashAmount" required />
            <label for="initialCashAmount">Initial Cash Amount</label>
          </div>
          <mat-form-field subscriptSizing="dynamic">
            <input matInput [matDatepicker]="myDatepicker" name="initialAccountDate" [(ngModel)]="initialAccountDate" placeholder="Initial Cash Account Date" />
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker name="date"></mat-datepicker>
          </mat-form-field>
          <div class="form-floating">
            <select id="company" name="company" class="form-control" [(ngModel)]="selectedCompany" required>
              <option value="0" disabled selected hidden>SELECT A COMPANY</option>
              @for (company of companyList; track company.ID) {
                <option [ngValue]="company.ID">{{ company.CompanyCode }}</option>
              }
            </select>
            <label for="company">Company</label>
          </div>
        }
        <button class="btn btn-primary" (click)="registerUser()">SIGN UP</button>
      </form>
    </div>
  </div>
</div>
